export default "__VITE_ASSET__kZI0ZiFI__"